<template>
  <div class="copyright-area copyright-style-one variation-two">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4 col-md-12 col-sm-12 col-12">
          <div class="copyright-left">

              <p class="copyright-text text-center link-hover">
                <img  :src="require(`@/assets/wangan.jpg`)" />闽公网安备 35020502000670号 |  <router-link to="/contact-us" style="color: #65676b">联系我们</router-link>
              </p>
              <p class="copyright-text text-center">
                版权所有 © 2023 耀协工贸 | <my-router-link  to="https://beian.miit.gov.cn" target="_blank">闽ICP备2022019185号-1</my-router-link>
              </p>
            </div>

        </div>
        <div class="col-lg-4 col-md-5 mt_md--10 mt_sm--10">
          <div class="copyright-right text-center text-lg-end">
          <ul class="social-icon social-default color-lessdark justify-content-center">
            <li> <img style="width: 100px;height: 100px;" class="logo-dark" :src="require(`@/assets/images/qrcode/code_1.png`)" alt="Corporate Logo"/></li>
            <li> <img style="width: 100px;height: 100px;" class="logo-dark" :src="require(`@/assets/images/qrcode/code_1.png`)" alt="Corporate Logo"/></li>
          </ul>
          </div>

        </div>

        <div class="col-lg-4 col-md-7 col-sm-12 col-12 mt_md--10 mt_sm--10">

          <div style="display:flex;justify-content: center; align-items:center;" >
            <div>

              <div  class="copyright-center" style="width: 300px;">
                <p class="copyright-text-first-name" >
                  厦门耀协工贸有限公司
                </p>
                <p class="copyright-text-first-english">
                  XIAMEN YAOXIE INDUSTRY AND TRADE CO., LTD
                </p>

              </div>
              <Separator/>

              <div class="copyright-center">
                <div>
                  <div class="copyright-text-second-name copyright-text" >
                    咨询热线：
                  </div>
                  <div class="copyright-text-second-text copyright-text" >
                    <template v-for="item in footList.phones">{{item.item1}}<br></template>
                  </div>
                </div>
                <div>
                  <div class="copyright-text-second-name copyright-text" >
                    公司邮箱：
                  </div>
                  <div class="copyright-text-second-text copyright-text" >
                    <template v-for="item in footList.emails">{{item.item1}}<br></template>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../icon/Icon'
import Separator from "../../elements/separator/Separator";
import MyRouterLink from "../MyRouterLink";
export default {
  name: 'CopyrightTwo',
  components: {Icon,Separator,MyRouterLink},
  data(){
    return{
      footList: {
        phones:[],
        emails:[]
      }
    }
  },
  created() {
    this.getFootContact();
  },
  methods:{
    getFootContact(){
      let footList =  window.sessionStorage.getItem("foot");
      if(footList){
        this.footList = JSON.parse(footList) ;
      }else{
        this.postRequest("/system/web/listFootContact").then(resp=>{
          var foots={
            phones:[],
            emails:[]
          };
          foots.phones = resp.data.phones;
          foots.emails = resp.data.emails;
          this.footList = foots;
          window.sessionStorage.setItem('foot',  JSON.stringify( this.footList));
        })
      }

    }

  }
}
</script>

<style scoped>
.copyright-text a{
  color: rgb(101, 103, 107);
}
</style>